<!-- 列表页表格 -->
<template>
    <el-table
        :data="tableObj.tableData"
        stripe
        style="width: 100%">
        <el-table-column
            v-for="(head,index) in tableObj.tableHead"
            :key="index"
            :prop="head.prop"
            :label="head.label"
            :align="head.align"
            :width="head.width?head.width*dpr:''">
            <template slot-scope="scope">
                <p
                    class="text_ellipsis"
                    :class="{'link':index==0}"
                    :title="scope.row[head.prop]"
                    @click="toDetail(type==3?scope.row.iHomeID:scope.row.SolutionID,type==3?scope.row.BidId:0)">
                    {{scope.row[head.prop]}}
                </p>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    import Util from '@/utils/Util';
    import permission from "@/mixins/permission.js";
    export default {
        mixins:[permission],
        data() {
            return {
                dpr:Util.setDpr()
            }
        },
        props:{
            tableObj:{
                type:Object,
                default(){
                    return {
                        tableHead:[],
                        tableData:[],
                    };
                }
            },
            type:{
                type:Number,//跳转详情类型 1 土地详情 2 项目详情 3招标详情
                default(){
                    return 1;
                }
            },
            module:{
                type:Number,//页面模块类型 1 房企拿地 2 房企项目开发 3全装修市场监控 4招标采购	
                default(){
                    return 1;
                }
            },
        },
        methods: {
            handleIconClick(key) {
                console.log(key);
                this.$emit('handleIconClick',key);
            },
            toDetail(id,bId=0){
                if(this.type==3){//招标详情
                    let routeData = this.$router.resolve({
                        path: '/page/detail',
                        query:{
                            module:this.module,  
                            type:this.type,  
                            id:id,
                            bId:bId
                        }
                    });
                    window.open(routeData.href, this.isScreen?'_self':'_blank');
                    // this.$router.push({
                    //     path: '/page/detail',
                    //     query:{
                    //         module:this.module,  
                    //         type:this.type,  
                    //         id:id,
                    //         bId:bId
                    //     }
                    // })
                }else{
                    if(this.userType==1){
                        this.showTip();
                        return
                    }
                    let routeData2 = this.$router.resolve({
                        path: '/page/detail',
                        query:{
                            module:this.module,  
                            type:this.type,  
                            id:id,
                        }
                    });
                    window.open(routeData2.href, this.isScreen?'_self':'_blank');
                    // this.$router.push({
                    //     path: '/page/detail',
                    //     query:{
                    //         module:this.module,  
                    //         type:this.type,  
                    //         id:id,
                    //     }
                    // })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>
